import React,{Component} from 'react';
import Button from '@react/react-spectrum/Button';
import _ from "lodash";
import i18n from "../../i18n";
import { withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import {updateToken, setLoderStatus} from "../../actions/SecurePaymentActions";
import {enableTokenizerErrorToastInfo,showScriptErrorMessage,showCyberSourceErrorMessage} from "../../actions/ToastActions";
import {Grid} from '@react/react-spectrum/Grid';
import Heading from '@react/react-spectrum/Heading';
class Tokenizer extends Component {

    constructor(props){
        super(props);
        console.log(props);
        this.state = {
            userDetails: props.userDetailsForTokenizer,
            loadTokenizerComponents: false
        };
        this.submitCardDetails = this.submitCardDetails.bind(this);
        this.sendToFrame = this.sendToFrame.bind(this);
        this.handleFrameTasks = this.handleFrameTasks.bind(this);
        this.props.setLoderStatus(true);
    }

    

    componentDidMount() {
      window.addEventListener("message", this.handleFrameTasks);
    }
    componentWillUnmount() {
      window.removeEventListener('message', this.handleFrameTasks);
    }

    sendToFrame(data) {
      if(this.ifr) this.ifr.contentWindow.postMessage(data, window.location.origin);
    }

    submitCardDetails(){
      var billingAddress = {}, addressDetails = {};
    if(this.state.userDetails){
      billingAddress = {
        street1: _.has(this.state.userDetails,'userAddress.address') ? this.state.userDetails.userAddress.address.trim() : '',
        city: _.has(this.state.userDetails,'userAddress.city') ? this.state.userDetails.userAddress.city.trim() : '',
        country: {code:_.has(this.state.userDetails,'countryCode') ? this.state.userDetails.countryCode : ''},
        stateProvince:{ code: _.has(this.state.userDetails,'userAddress.state') ? this.state.userDetails.userAddress.state : ''} ,
        postalCode: _.has(this.state.userDetails,'userAddress.postalCode') ? this.state.userDetails.userAddress.postalCode : '',
      };
      addressDetails = {
        'actionType':"CARD_DETAILS_SUBMITTED",
        'customerAddress': billingAddress,
        'contact' :{
            'firstName': _.has(this.state.userDetails,'first_name') ? this.state.userDetails.first_name : '',
            'lastName': _.has(this.state.userDetails,'last_name') ? this.state.userDetails.last_name : '',
            'phone': _.has(this.state.userDetails,'phoneNumber') ? this.state.userDetails.phoneNumber : '',
            'primaryEmail':  _.has(this.state.userDetails,'email') ? this.state.userDetails.email : ''
        }
      };
    }
        this.props.setLoderStatus(true);
        this.sendToFrame(addressDetails);
      }

      handleTokenizerError(data){
        var errorType = _.has(data, 'value.errorType') ? data.value.errorType : '';
        if(errorType.indexOf('TOKEN_CYBERSOURCE_ERROR') > -1){
          errorType = 'TOKEN_CYBERSOURCE_ERROR';
        }
        switch(errorType){
          case 'TOKEN_MISSING_INPUT' :
          case 'TOKEN_INVALID_INPUT' :      this.props.setTokenizerErrorFlag(true);
                                            this.props.setLoderStatus(false);
                                            break;
          case 'TOKEN_CYBERSOURCE_ERROR' :  this.props.setCyberSourceErrorFlag(true);
                                            this.props.setLoderStatus(false);
                                            this.setState({loadTokenizerComponents: false});
                                            break;
          default:                          this.props.setLoderStatus(false);
                                            break;
        }
      }
    
      handleFrameTasks = (e) => {
        try{
          var eventData;
          if(typeof(e.data) == 'string'){
            eventData = JSON.parse(e.data);
            switch(eventData.type){
              case 'tokenTempTokenReceived':
              case 'tokenReceived'  : var tokenDetails= {"type":"TOKEN","content":"Token: " + eventData.value.token_id+" | Card Type: "+eventData.value.payment_instrument.payment_type + " | Expiry: " +eventData.value.payment_instrument.credit_card_expiry_date_display  + " | Card Span: " + eventData.value.payment_instrument.credit_card_span,"createdBy":"SecurePaymentPortal"};
              if(this.props.termsConditionAccepted){
                tokenDetails.content =  tokenDetails.content + '| termsAccepted : true';
              }
                                      this.props.updateToken(tokenDetails);
                                      break;
              case 'tokenError'     : this.handleTokenizerError(eventData);
                                      break;
              case 'scriptError'    : this.props.setScriptErrorFlag(true);
                                      this.props.setLoderStatus(false);
                                      break;
              case 'tokenLoaded'    : this.props.setLoderStatus(false);
                                      this.setState({loadTokenizerComponents: true});
                                      break;
              default               : break;
            }
          }
        }catch(e){
          console.error(e)
        }
      }

      renderTokenizer(){
        return (
            <div className="tokenizer-form-outer">              
              <Grid variant="fixed">
                {this.state.loadTokenizerComponents ? <Heading className="form-heading" variant="subtitle1" style={{paddingLeft: '10px'}} data-am-id="tokenizerHeading">{i18n.t('tokenizerHeaderMessage')}</Heading>: ''}
                <div id="payment-tokenizer" className="align-center">
                  <iframe title="tokenizer iFrame"
                  id="tokenizer-iframe"                
                  style={{ width: '100%', border: 'none', height:'190px' }}
                  scrolling="no"
                  src={process.env.PUBLIC_URL + '/tokenizer/tokenizer.html?countryCode=' + this.state.userDetails.countryCode + '&languageCode=' + this.props.localeLanguageCode}
                  ref={(f) => { this.ifr = f; }}
                  />
                </div>
                {this.state.loadTokenizerComponents ? <div className="align-center">
                  {this.props.enableBackButton ? <Button variant="cta" onClick={this.props.previousPage} data-am-id="tokenBackBtn">{i18n.t('label.backBtn')}</Button> : ''}
                  <Button variant="cta" onClick={this.submitCardDetails} data-am-id="tokenSubmitBtn">{i18n.t('label.submitBtn')}</Button>
                </div>: ''}
              </Grid>              
            </div>
        )
      }

      render() {
            return (
              this.renderTokenizer()
            );
        }    
}

const mapStateToProps = (state)=>{
  return{
      showSuccessMsg:state.ToastReducer.showSuccessToast,
      showTokenizerErrorToast:state.ToastReducer.showTokenizerErrorToast,
      userDetails:state.AuthReducer.userInfo,
      locale:state.LocaleReducer.goUrlLocale,
      isLoaderStatus: state.SecurePaymentReducer.isLoaderStatus,
      localeLanguageCode: state.LocaleReducer.languageCode,
      termsConditionAccepted: state.UserInfoReducer.termsConditionAccepted
  }
};

const mapDispatchToProps = (dispatch)=>{
  return{
      updateToken:(tokenDetails)=>{dispatch(updateToken(tokenDetails))},
      setTokenizerErrorFlag:(flag)=>{dispatch(enableTokenizerErrorToastInfo(flag))},
      setLoderStatus:(flag)=>{dispatch(setLoderStatus(flag))},
      setScriptErrorFlag:(flag)=>{dispatch(showScriptErrorMessage(flag))},
      setCyberSourceErrorFlag:(flag)=>{dispatch(showCyberSourceErrorMessage(flag))}
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(Tokenizer));

